

import { Link, useParams} from "react-router-dom";
import { useState, useEffect } from "react";
import loginIcon from "../../imagenesLogin/login-icon.svg"
import vdpIcon from "../../imagenesLogin/VdpLogo.png"
import passwordIcon from "../../imagenesLogin/password-icon.svg"
import axios, { Axios } from "axios";
import API from '../utils/api';
import Alerta  from '../Alerta'


const NuevoPassword = () => {
    const [tokenValido, setTokenValido]= useState(false)
    const [alerta, setAlerta] = useState({})
    const [passwordModificado, setPasswordModificado] = useState(false)
    const [password, setPassword] = useState("")
    var url = API.urlAPI

    const params = useParams()
    const {token} = params
    const urlOlvidePassword = url + "usuarios/olvide-password/"+token
    useEffect(()=>{
        const comprobarToken = async ()=>{
            try {
                await axios(urlOlvidePassword)
                setTokenValido(true)
            } catch (error) {
              setAlerta({
                msg: error.response.data.msg,
                error: true
            })
            }
        }
        comprobarToken()
    },[])


  const handleSubmit= async e=>{
    
    if(password.length <6){
      console.log("El password debe ser minimo de 6 caracteres")
        setAlerta({
          msg: "El password debe ser minimo de 6 caracteres",
          error:true
        })
        return
    }
    try {
      const {data} = await axios.post(urlOlvidePassword, {password:password})
      setAlerta({
        msg: data.msg,
        error:false
      })
      setPasswordModificado(true)
    } catch (error) {
      setAlerta({
        msg: error.response.data.msg,
        error:true
      })
    }

  }
  const { msg } = alerta
  return (
    <>
    {msg && !tokenValido&&
            <Alerta alerta={alerta}></Alerta>
    }
    { tokenValido &&(
        <div className=" d-flex justify-content-center align-items-center mt-5">
       
        <div
          
          className="bg-white p-5 rounded-5 text-secondary shadow "
          style={{width: "25rem"}}
        >
          
          <div className="d-flex justify-content-center" >
            <img
              src={vdpIcon}
              alt="login-icon"
              style={{height: "6rem"}}
            />
          </div>
          
          <div className="text-center fs-1 fw-bold">Nueva Contraseña</div>
            {msg && 
            <Alerta alerta={alerta}></Alerta>
            }
    
          <div className="input-group mt-1">
            <div className="input-group-text" style={{ background: "#005187" }}>
              <img
                src={passwordIcon}
                alt="password-icon"
                style={{height: "1rem"}}
              />
            </div>
            <input
              className="form-control bg-light"
              type="password"
              placeholder="contraseña"
              value={password}
              onChange={e=>setPassword(e.target.value)}
            />
          </div>
          
      
          <div className="btn text-white w-100 mt-4 fw-semibold shadow-sm"onClick={handleSubmit} style={{ background: "#005187" }}>
            Generar contraseña
          </div>
      
        </div>
        </div>
    )}
       {passwordModificado && (
                    <Link 
                        className='inicia-sesion'
                        to="/"
                    >Inicia Sesión</Link>
            )}
    </>
  )
}

export default NuevoPassword